module.exports = __webpack_public_path__ + "static/media/single-arrow-left.974f0cec.svg";